var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroupsAdd = function SvgGroupsAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "groups_add_svg2__a",
    x1: 123.44,
    x2: 230.93,
    y1: 244.93,
    y2: 117.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#groups_add_svg2__a",
    id: "groups_add_svg2__c",
    x1: 54.82,
    x2: 162.31,
    y1: 187.23,
    y2: 59.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#groups_add_svg2__a",
    id: "groups_add_svg2__d",
    x1: 62.82,
    x2: 170.32,
    y1: 193.96,
    y2: 66.13
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#groups_add_svg2__a",
    id: "groups_add_svg2__e",
    x1: -4.16,
    x2: 103.33,
    y1: 137.63,
    y2: 9.81
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#groups_add_svg2__a",
    id: "groups_add_svg2__f",
    x1: -1.85,
    x2: 105.64,
    y1: 139.57,
    y2: 11.75
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M194.34 173.21h-9.69v-9.69c0-3.13-2.53-5.66-5.66-5.66s-5.66 2.53-5.66 5.66v9.69h-9.69a5.661 5.661 0 0 0 0 11.32h9.69v9.68c0 3.13 2.53 5.66 5.66 5.66s5.66-2.53 5.66-5.66v-9.68h9.69a5.661 5.661 0 0 0 0-11.32",
    style: {
      fill: "url(#groups_add_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.56 126.32c8.03-5.02 13.37-13.92 13.39-24.08 0-15.68-12.71-28.39-28.39-28.39s-28.39 12.71-28.39 28.39c0 10.16 5.34 19.07 13.37 24.09-15.1 5.98-25.78 20.71-25.78 37.94v14.89c0 1.98 1.6 3.58 3.58 3.58h74.43c1.98 0 3.58-1.6 3.58-3.58v-14.89c0-17.23-10.69-31.97-25.79-37.95m-36.24-24.08c0-11.73 9.51-21.23 21.24-21.23 11.72.01 21.22 9.51 21.24 21.23 0 11.72-9.5 21.22-21.22 21.23h-.04c-11.72-.01-21.22-9.51-21.22-21.23m54.88 73.33H57.92v-11.31c0-18.58 15.06-33.64 33.64-33.64s33.64 15.06 33.64 33.64z",
    style: {
      fill: "url(#groups_add_svg2__c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.31 82.2c-1.71.68-3.38 1.47-5.03 2.4a3.57 3.57 0 0 0-1.35 4.85c.97 1.72 3.15 2.34 4.87 1.37a33.6 33.6 0 0 1 16.5-4.33c18.58 0 33.65 15.06 33.66 33.64v11.31h-45.22c-1.97 0-3.58 1.6-3.58 3.58s1.6 3.58 3.58 3.58h48.79c1.97 0 3.58-1.6 3.58-3.58v-14.89c0-7.01-1.81-13.91-5.25-20.02-4.78-8.49-12.15-14.6-20.55-17.92 8.04-5.01 13.39-13.93 13.4-24.09 0-15.68-12.71-28.39-28.39-28.39s-28.39 12.71-28.39 28.39c0 10.16 5.35 19.08 13.38 24.09Zm15.01-45.32c11.72.01 21.22 9.51 21.23 21.23 0 11.66-9.39 21.11-21.02 21.23h-.38c-11.65-.09-21.07-9.56-21.07-21.23 0-11.73 9.51-21.23 21.24-21.23",
    style: {
      fill: "url(#groups_add_svg2__d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.95 135.03c0-1.98-1.6-3.58-3.58-3.58H7.15v-11.31c0-5.78 1.49-11.46 4.33-16.5 6.14-10.91 17.46-17.08 29.15-17.14h.28c5.57.01 11.21 1.41 16.4 4.33 1.72.97 3.9.37 4.87-1.35s.36-3.9-1.36-4.87c-1.63-.92-3.32-1.72-5.05-2.4 8.03-5.01 13.38-13.92 13.4-24.09 0-15.68-12.71-28.39-28.39-28.39S12.39 42.44 12.39 58.12c0 10.16 5.35 19.08 13.38 24.09C10.68 88.18 0 102.91 0 120.14v14.89c0 1.98 1.6 3.58 3.58 3.58h48.79c1.98 0 3.58-1.6 3.58-3.58M19.56 58.11c0-11.73 9.51-21.23 21.24-21.23 11.72.01 21.22 9.51 21.23 21.23 0 11.73-9.51 21.23-21.23 21.23s-21.24-9.51-21.24-21.23",
    style: {
      fill: "url(#groups_add_svg2__e)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.56 56.89c15.67-.02 28.37-12.72 28.39-28.39 0-15.67-12.71-28.38-28.39-28.38S63.17 12.83 63.17 28.51 75.88 56.9 91.56 56.9Zm0-49.62c11.72.01 21.22 9.51 21.24 21.23 0 11.73-9.51 21.23-21.24 21.23S70.32 40.22 70.32 28.5 79.83 7.27 91.56 7.27",
    style: {
      fill: "url(#groups_add_svg2__f)",
      strokeWidth: 0
    }
  }));
};
export default SvgGroupsAdd;